<template>
  <div class="scenario_inputs">
    <div
        v-for="item in checkBox"
        class="form-group from_main flex">
      <p class="radioTitle flex_text big_radio_text">{{ item.name }}</p>
      <div class="flex_box big-radio flex">
        <div class="setup">
          <input type="radio"
                 @change="selectOne"
                 :id="item.public.label"
                 :value="item.public.price"
                 v-model="item.selected">
          <label :for="item.public.label">
            <span class="remind">公立</span>
          </label>
        </div>
        <div class="setup">
          <input type="radio"
                 @change="selectOne"
                 :id="item.private.label"
                 :value="item.private.price"
                 v-model="item.selected">
          <label :for="item.private.label">
            <span class="remind">私立</span>
          </label>
        </div>
      </div>
    </div>
    <div>{{ tip }}</div>
  </div>
</template>

<script>
import {get, dispatch} from 'vuex-pathify'

export default {
  name: "multiple_checkbox",
  props: {
    options: Array,
    page_no: Number,
    tip: String
  },
  data: function () {
    return {
      checkBox: [
        {
          name: '幼稚園',
          name_en: 'kindergarten',
          public: {
            price: 50000,
            label: 'label1'
          },
          private: {
            price: 180000,
            label: 'label2'
          },
          selected: 50000
        },
        {
          name: '國小',
          name_en: 'elementary',
          public: {
            price: 70000,
            label: 'label3'
          },
          private: {
            price: 120000,
            label: 'label4'
          },
          selected: 70000
        },
        {
          name: '國中',
          name_en: 'junior',
          public: {
            price: 114000,
            label: 'label5'
          },
          private: {
            price: 157600,
            label: 'label6'
          },
          selected: 114000
        },
      ]
    }
  },
  methods: {
    selectOne() {
      let page_answer = {}
      this.checkBox.forEach(item => {
        page_answer[item.name_en] = item.selected
      })
      let moduleName = store.get('moduleName')
      dispatch(moduleName + '/setPostData', {page_no: this.page_no, page_answer: page_answer})
    }
  },
  mounted() {
    this.selectOne()
  },
}
</script>

<style scoped>

</style>